import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ToastAx             from 'app/actions/toast';
import Checkbox            from 'app/components/common/checkbox';
import Modal               from 'app/components/common/modal';
import RteEditor           from 'app/components/common/rich-text/editor';
import StandardInput       from 'app/components/common/standard-input';
import StandardSelect      from 'app/components/common/standard-select';
import FormForm            from 'app/components/company-admin/forms/builder-form-form';
import Builder             from 'app/components/company-admin/layout/builder';
import BuilderFooter       from 'app/components/company-admin/layout/builder-footer';
import BuilderSection      from 'app/components/company-admin/layout/builder-section';
import BuilderSectionGroup from 'app/components/company-admin/layout/builder-section-group';
import ProgramAppForm      from 'app/components/grant-system/program-app-form';
import GrantSysDuck        from 'app/ducks/company-admin/grant-system';
import FormsDuck           from 'app/ducks/company-admin/forms';
import formsHelpers        from 'app/helpers/forms';
import helpers             from 'app/helpers/grant-system';
import utils               from 'app/helpers/utils';
import history             from 'app/history';
import paths               from 'app/paths';
import prompts             from 'app/prompts';
import AuthSlx             from 'app/selectors/auth';
import CadminSlx           from 'app/selectors/company-admin/';
import EntitiesSlx         from 'app/selectors/entities';

const {Steps} = ProgramAppForm;

const formToDetails = (form, index) => {
  return {
    label: form.title || `Form #${index+1}`,
    isActive: !!form._active,
    isDeleted: !!form._delete,
  };
};

class GrantProgramAppFlowBuilder extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      hasTouched: false,
      hasSubmitted: false,
      isSaving: false,
      showAddFormModal: false,
      selectedSharedFormId: null,
      // formsSaveAttrs: {},
    };

    this.refSortableList = React.createRef();

    this.onSortForms = this.onSortForms.bind(this);
    this.onClickForm = this.onClickForm.bind(this);
    this.onChangeEntryText = this.onChangeEntryText.bind(this);
    this.onChangeSubmitText = this.onChangeSubmitText.bind(this);
    this.onChangeThankyouText = this.onChangeThankyouText.bind(this);
    this.onChangeIncludeAck = this.onChangeIncludeAck.bind(this);
    this.onChangeAckText = this.onChangeAckText.bind(this);
    // this.onSelectForm = this.onSelectForm.bind(this);
    this.onClickCreateNewForm = this.onClickCreateNewForm.bind(this);
    this.onClickAddSharedForm = this.onClickAddSharedForm.bind(this);
    this.onChangeForm = this.onChangeForm.bind(this);
    this.onDeleteForm = this.onDeleteForm.bind(this);
    this.onClickAddForm = this.onClickAddForm.bind(this);
    this.onCloseAddForm = this.onCloseAddForm.bind(this);
    this.onSelectSharedForm = this.onSelectSharedForm.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
  }

  /*
   *  Helpers
   */

  get saveAttrs() {
    const {program} = this.props;
    const sanitizeString = str => (str || '').trim() || null;
    return {
      entryText: sanitizeString(program.entryText),
      ackText: sanitizeString(program.ackText),
      submitText: sanitizeString(program.submitText),
      thankyouText: sanitizeString(program.thankyouText),
      formIds: program.formIds || [],
    };
  }

  get changedForms() {
    const {formIds=[]} = this.props.program;
    return Object.values(this.props.program.formMap || {})
      .filter(form => formIds.includes(form.id));
  }

  get validations() {
    const {program} = this.props;
    const v = {};
    // TODO: require stuff
    // if (!program.entryText) v.entryText = ['required'];
    if (!Object.keys(v).length) return null;
    return v;
  }

  get visibleValidations() {
    if (!this.state.hasTouched) return null;
    if (!this.state.hasSubmitted) return null;
    return this.validations;
  }

  get addFormOptions() {
    const sharedFormOpts = this.props.sharedForms
      .filter(form => !this.props.program.formIds.includes(form.id))
      .map(form => ({value: form.id, label: form.title}));
    return sharedFormOpts;
    // return [
    //   {value: 'NEW', label: 'Create New Form'},
    //   {type: 'hr'},
    //   ...sharedFormOpts,
    // ];
  }

  get forms() {
    const {formMap, program} = this.props;
    const changedMap = program.formMap || {};
    const combinedMap = {...formMap, ...changedMap};
    return program.formIds.map(id => combinedMap[id]).filter(f => f);
  }

  onChangeEntryText(md) {
    this.setState({hasTouched: true});
    const entryText = md;
    this.props.setAttrs({entryText});
  }
  onChangeSubmitText(md) {
    this.setState({hasTouched: true});
    const submitText = md;
    this.props.setAttrs({submitText});
  }
  onChangeThankyouText(md) {
    this.setState({hasTouched: true});
    const thankyouText = md;
    this.props.setAttrs({thankyouText});
  }

  onChangeIncludeAck(event) {
    this.setState({hasTouched: true});
    const includeAck = event.target.checked;
    const ackText = includeAck ? helpers.DEFAULT_ACK_TEXT : null;
    this.props.setAttrs({ackText});
  }
  onChangeAckText(event) {
    this.setState({hasTouched: true});
    const ackText = event.target.value;
    this.props.setAttrs({ackText});
  }

  onClickAddSharedForm() {
    const {selectedSharedFormId: formId} = this.state;
    if (!formId) return;
    const prevFormIds = this.props.program.formIds || [];
    const formIds = [...prevFormIds, formId];
    this.setState({showAddFormModal: false}, () => {
      this.props.setAttrs({formIds});
      this.props.onChangeStep(formId);
    });
  }
  onClickCreateNewForm() {
    const {program} = this.props;
    const setAttrs = {}
    const prevFormIds = program.formIds || [];
    const prevFormMap = program.formMap || {};
    const title = `Form #${program.formIds.length + 1}`;
    const form = formsHelpers.makeNewForm({ownerType: 'GrantProgram', ownerId: program.id, title});
    setAttrs.formMap = {...prevFormMap, [form.id]: form};
    setAttrs.formIds = [...prevFormIds, form.id];
    this.setState({showAddFormModal: false}, () => {
      this.props.setAttrs(setAttrs);
      this.props.onChangeStep(form.id);
    });
  }

  onClickAddForm() {
    this.setState({showAddFormModal: true, selectedSharedFormId: null});
  }
  onCloseAddForm() {
    this.setState({showAddFormModal: false});
  }
  onSelectSharedForm(selectedSharedFormId) {
    this.setState({selectedSharedFormId});
  }

  onChangeForm(form) {
    this.setState({hasTouched: true});
    const formMap = {...(this.props.program.formMap || {})};
    formMap[form.id] = form;
    this.props.setAttrs({formMap});
  }

  async onDeleteForm(index) {
    const form = this.forms[index];
    const isShared = !form.ownerId;
    const msg = isShared
      ? `Are you sure you want to remove form "${form.title}" from the application flow?\nThis change won't take effect until you click Save.`
      : `Are you sure you want to delete form "${form.title}"?\nThis change won't take effect until you click Save.`;
    const didConfirm = await prompts.confirm({msg, danger: isShared ? 'Remove' : 'Delete'});

    if (didConfirm) {
      this.setState({hasTouched: true});
      const formIds = [...this.props.program.formIds];
      formIds.splice(index, 1);
      this.props.setAttrs({formIds});
    }
  }

  onSortForms(forms) {
    this.setState({hasTouched: true});
    const formIds = forms.map(f => f.id);
    this.props.setAttrs({formIds});
  }
  onClickForm(form) {
    this.props.onChangeStep(form.id);
  }
  onClickStep(step) {
    this.props.onChangeStep(step);
  }


  async saveForms() {
    // need to persist each form that's been modified
    // for each one, we also need to set its id in program.formIds as persisting it may assign a new (temporary->permanent) id
    const changedForms = this.changedForms;
    try {
      await utils.series(changedForms, async (form, i) => {
        const saveAttrs = formsHelpers.getFormSaveAttrs(form, {forceValid: true});
        const resp = await this.props.saveForm(form, saveAttrs);
        const formIds = utils.arrReplace(this.props.program.formIds, {[form.id]: resp.form.id});
        this.props.setAttrs({formIds});
      });
    } catch (error) {
      this.props.toastError('Oops! Something went wrong while saving forms.');
      throw error;
    }
  }
  async saveProgram() {
    try {
      await this.props.update(this.saveAttrs);
    } catch (error) {
      this.props.toastError('Oops! Something went wrong while saving program.');
      throw error;
    }
  }
  async onClickSave() {
    if (this.validations) {
      this.setState({hasSubmitted: true});
      return;
    }
    this.setState({hasSubmitted: true, isSaving: true});
    try {
      await this.saveForms();
      await this.saveProgram();
    } catch (error) {
      this.setState({isSaving: false});
      console.error(error);
      throw error;
    }
    this.setState({isSaving: false});
    this.props.toastSuccess('Application flow updated.');
    const managePath = paths.cadminGrantProgram(this.props.program.company.slug, this.props.program.id, {tab: 'config'});
    history.push(managePath);
  }

  renderFooter() {
    const btnDisabled = (() => {
      if (this.state.isSaving) return true;
      if (this.visibleValidations) return true;
      if (!this.state.hasTouched) return true;
      return false;
    })();
    const btnText = (() => {
      return 'Save';
    })();

    return (
      <BuilderFooter>
        {!!this.visibleValidations && (
          <div className="cadmin-builder-bottom-validations">
            <p>Oops! There are some required fields above that need your attention.</p>
          </div>
        )}
        <div className="cadmin-builder-bottom-actions">
          <button className="btn green" disabled={btnDisabled} onClick={this.onClickSave}>{btnText}</button>
        </div>
      </BuilderFooter>
    );
  }

  renderStartScreen() {
    const {company, program, step} = this.props;
    if (step !== Steps.START) return null;
    const includeAck = program.ackText != null;
    const saTopRight = (
      <Checkbox checked={includeAck} onChange={this.onChangeIncludeAck} isToggle />
    );

    return (
      <BuilderSectionGroup.V2 title="Start Screen" collapsible={false}>
        <BuilderSection title="Description">
          <RteEditor placeholder="Terms, eligibility requirements, instructions, etc..." name="entryText" initialMd={program.entryText} onChange={this.onChangeEntryText} validations={this.visibleValidations} tall />
        </BuilderSection>

        <BuilderSection title="Acknowledgement" topRight={saTopRight}>
          {!!includeAck && (
            <StandardInput name="ackText" value={program.ackText || ''} onChange={this.onChangeAckText} label="By clicking below you agree..." />
          )}
          {/* <pre>{JSON.stringify({formIds: program.formIds, changedForms: this.changedForms, formMap: this.props.program.formMap},null,4)}</pre> */}
        </BuilderSection>
      </BuilderSectionGroup.V2>
    );
  }

  renderForms() {
    const {program, company, step} = this.props;

    return (<>
      {this.forms.map((form, i) => {
        if (step !== form.id) return null;
        return (
          <BuilderSectionGroup.V2
            key={form.id}
            index={i}
            title={`${form.title || ''}`}
            onDelete={this.onDeleteForm}
            collapsible={false}
          >
            <FormForm form={form} onChange={this.onChangeForm} parentId={program.id} company={company} validations={null} />
          </BuilderSectionGroup.V2>
        );
      })}
    </>);
  }

  renderReviewScreens() {
    const {program, step} = this.props;
    if (step !== Steps.REVIEW) return null;

    return (<>
      <BuilderSectionGroup.V2 title="Review Screen" collapsible={false}>
        <BuilderSection title="Text">
          <RteEditor placeholder="Final instructions, review timelines, etc..." name="submitText" initialMd={program.submitText} onChange={this.onChangeSubmitText} validations={this.visibleValidations} tall />
        </BuilderSection>
      </BuilderSectionGroup.V2>
      <BuilderSectionGroup.V2 title="Thank You Screen" collapsible={false}>
        <BuilderSection title="Text">
          <RteEditor placeholder="Thank you - we'll be in touch soon!" name="thankyouText" initialMd={program.thankyouText} onChange={this.onChangeThankyouText} validations={this.visibleValidations} tall />
        </BuilderSection>
      </BuilderSectionGroup.V2>
    </>);
  }

  renderAddFormModal() {
    const {showAddFormModal, selectedSharedFormId} = this.state;
    if (!showAddFormModal) return null;

    return (
      <Modal className="bform" onClose={this.onCloseAddForm}>
        <h1 className="bform-h1">Add Form to Application Flow</h1>

        <h2 className="bform-h2">Create New</h2>
        <p>Create a new form specifically for this grant program.</p>
        <button className="btn blue" onClick={this.onClickCreateNewForm}>Create New Form</button>

        <h2 className="bform-h2">Shared Forms</h2>
        <p>Choose a shared form to add to this application flow. Shared forms can be used by more than one grant program and can be edited outside of this program.</p>
        <div className="_flex _justify-start _align-center _gap-12">
          <StandardSelect options={this.addFormOptions} onSelect={this.onSelectSharedForm} label="Select shared form" value={selectedSharedFormId} className="_flex-1" />
          <button className="btn blue" disabled={!selectedSharedFormId} onClick={this.onClickAddSharedForm}>Add Shared Form</button>
        </div>
      </Modal>
    );
  }

  render() {
    const {company, program, step} = this.props;

    return (
      <Builder footer={this.renderFooter()} className="ca-bldr-gpaf">
        {this.renderStartScreen()}
        {this.renderForms()}
        {this.renderReviewScreens()}
        {this.renderAddFormModal()}
      </Builder>
    );
  }

}

GrantProgramAppFlowBuilder.propTypes = {
  program: PropTypes.object.isRequired,
  step: PropTypes.string,
  onChangeStep: PropTypes.func.isRequired,
};

const stateToProps = (state) => ({
  currentUser: AuthSlx.currentUser(state),
  company: CadminSlx.company(state),
  program: GrantSysDuck.Slx.bldrAppProg(state),
  formMap: EntitiesSlx.forms(state),
  sharedForms: FormsDuck.Slx.sharedForms(state),
});

const dispatchToProps = (dispatch, ownProps) => ({
  setAttrs: (keyVals) => dispatch(GrantSysDuck.Ax.setBuilderAppProgram(keyVals)),
  update: (attrs) => dispatch(GrantSysDuck.Ax.programsUpdate(ownProps.program.company.id, ownProps.program.id, attrs)),
  saveForm: (form, attrs) => dispatch(FormsDuck.Ax.save(form, attrs, {redirect: false})),
  toastError: (msg) => dispatch(ToastAx.error(msg)),
  toastSuccess: (msg) => dispatch(ToastAx.success(msg)),
});

export default connect(stateToProps, dispatchToProps, null, {forwardRef: true})(GrantProgramAppFlowBuilder);
